"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.controls.knowledgePicker.label': 'Wybierz Wiedzę',
    'ai.controls.knowledgePicker.show': 'Użyj Bazy Wiedzy',
};
